__turbopack_context__.v({
  "blok-big-title": "ToggleSection-module__obUD7G__blok-big-title",
  "blok-subtitle": "ToggleSection-module__obUD7G__blok-subtitle",
  "blok-title": "ToggleSection-module__obUD7G__blok-title",
  "header": "ToggleSection-module__obUD7G__header",
  "root": "ToggleSection-module__obUD7G__root",
});
